<template>
	<div class="topiclist flex-ac">
    <img v-lazy="topicItem.img" @click="goList">
    <div class="flex-1 flex-js-as flex-dc topic" :class="{'flex-jc': !topicItem.remark}" @click="goList">
      <div class="flex-ac topictitle">
        <img width="14" height="14" src="/static/images/community/community-topic-selected.png">
        <span class="f16 over-ell-2">{{topicItem.subject}}</span>
      </div>
      <p class="f14 over-ell-2">{{topicItem.remark}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topicListComp',
  props: {
    topicItem: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    goList: function () {
      if (this.topicItem.url) {
        window.location = this.topicItem.url
      } else {
        this.$router.push({
          path: '/communityfollow',
          query: {
            subjectid: this.topicItem.subjectid,
            subject: encodeURIComponent(this.topicItem.subject)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .topiclist {
    background: #ffffff;
    padding: 0.1rem 0.11rem;
    position: relative;
    &:after {
      content: '';
      display: block;
      height: 0.01rem;
      position: absolute;
      bottom: 0;
      left: 0.11rem;
      right: 0.11rem;
      background: #F5F5F5;
    }
    >img {
      width: 1.12rem;
      height: 0.56rem;
      border-radius: 0.04rem;
    }
    .topic {
      color: #FC0324;
      min-height: 0.56rem;
      /*padding-top: 0.03rem;*/
      margin-left: 0.08rem;
      img {
        margin-right: 0.04rem;
      }
      p {
        color: #222222;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/topicListComp.vue